module.exports = "<ul class=holding-dashboard-sidebar-help-list ng-transclude></ul> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/common/directives/sidebar-list/sidebar-list.html
// module id = 298
// module chunks = 0